import "./DetailedOffer.css";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../../../Localization/Translation";

const DetailedOffer = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));

  var Details = {
    id: 1,
    name: "مغسلة السعودية",
    date: "25/12/2020",
    categories: [" برونزي", " ذهبي", " فضي"],
  };

  return (
    <div className="DetailedRequest-modal" dir="auto">
      <div className="det-modal-offer-row">
        <span>
          <i className="fa fa-building" aria-hidden="true"></i>
          {translate("laundry-name", locale)}:
        </span>
        <span>{Details.name}</span>
      </div>
      <div className="det-modal-offer-row">
        <span>
          <i className="fa fa-calendar" aria-hidden="true"></i>
          {translate("date-of-request", locale)}:
        </span>
        <span>{Details.date}</span>
      </div>
      <div className="det-modal-offer-row">
        <span>
          <i className="fa fa-users" aria-hidden="true"></i>
          {translate("categories-label-offer", locale)}
        </span>
        <span>{Details.categories.toString()}</span>
      </div>
      <div className="det-modal-offer-row">
        <span>
          <i className="fa fa-clock-o" aria-hidden="true"></i>
          {translate("offer-time-label", locale)}
        </span>
        <div>
          <div className="offer-period-row">
            <span>{translate("from", locale)}</span>
            <span>10/12/2022</span>
          </div>
          <div className="offer-period-row">
            <span>{translate("to", locale)}</span>
            <span>12/12/2022</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailedOffer;
